import { Link } from "react-router-dom";

type Props = {
  eyebrow?: string;
  title: string;
  description?: string;
  linkTo?: string;
  linkLabel?: string;
};

export default function SectionHeader({ eyebrow, title, description, linkTo, linkLabel }: Props) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div className="max-w-2xl">
        {eyebrow && (
          <p className="flex items-center gap-2 font-label text-[11px] uppercase tracking-[0.28em] text-primary-500">
            <span className="h-px w-6 bg-primary-500"></span>
            {eyebrow}
          </p>
        )}
        <h2 className="mt-2.5 font-heading text-2xl font-semibold leading-tight text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {description && (
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">{description}</p>
        )}
      </div>
      {linkTo && (
        <Link
          to={linkTo}
          className="group flex shrink-0 cursor-pointer items-center gap-1.5 self-start rounded-full border border-background-300/60 px-4 py-2 font-label text-xs text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-500 sm:self-auto"
        >
          {linkLabel || "查看全部"}
          <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-0.5"></i>
        </Link>
      )}
    </div>
  );
}